/* ==========================================================================
   mlx-card-atc.js — 상품 카드 ATC · 쉐이드 시트 · NOTIFY ME (2026-08-10 CC)
   테마: phase1-hotfix4-footer-20260809 / 198578045088 (UNPUBLISHED)
   로더: layout/theme.liquid CB 블록 (stylesheet_tag + script 두 줄)
   롤백: 그 두 줄 삭제
   설계 근거는 규격_ATC컴포넌트.md §1 · §4 · §7 에 있다. 주석은 짧게 유지한다.

   ★ 지우면 안 되는 것 (전부 실측으로 데인 것들)
     · `.mlx-card-dots[data-mlx-shades]` = 시트 스와치 URL 의 유일한 출처.
       없으면 제품컷 폴백으로 12장 ≈ 7.8MB 가 나가고 색도 틀린다.
     · 시트 <img> 에 loading="lazy" 금지 — display:none 상태라 끝까지 로드되지 않는다.
     · 담김 판정은 /cart.js item_count 증가로만. 기준값을 못 읽으면 침묵한다.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__mlxCardAtc) { return; }
  window.__mlxCardAtc = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function u(p) { return (ROOT.charAt(ROOT.length - 1) === '/' ? ROOT : ROOT + '/') + p; }

  /* ── Klaviyo Back in Stock ────────────────────────────────────
     PDP `snippets/product__notify-me-form.liquid` (AV 2026-08-08) 와 같은 경로.
     ★ NOTIFY_CONFIRMED — Klaviyo 프로필 적재와 Back in Stock 플로우 Live 여부를
       확인할 경로가 없다. 확인 전까지 "구독됐다" 는 말을 하지 않는다.
       실제 확인되면 이 값만 true 로 바꾸면 확정 문구가 켜진다. */
  var KLAVIYO_EP = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var KLAVIYO_REV = '2024-10-15';
  var NOTIFY_CONFIRMED = false;

  var SHOP_ALL = false;

  /* ------------------------------------------------------------------ cart label
     [2026-08-10 CE] The bar carries a compare-at price on sale cards now, and a
     narrow bar cannot show that next to the full label. Measured at 375: 24
     padding + 82.0 "ADD TO CART" + 8 gap + 74.4 for "$30.00 $26.00" = 189.8px
     needed against a 159.5px bar, so the label shortens to the owner-approved
     "Buy" (painted "BUY" - .mlx-atc is text-transform:uppercase).

     !! Do NOT turn this back into a viewport media query. The first attempt used
       max-width:480px and was WRONG: the grid goes 2-up below 799 and 4-up above
       it, and the 4-up cards start NARROWER than the 2-up ones. Measured card
       widths: 375 -> 159.5, 800 -> 162.3, 940 -> 197.3, 1440 -> 301. A viewport
       rule that covers the phone leaves 799-933 clipping (verified at 800: label
       scrollWidth 82 vs clientWidth 48).
     So the page measures itself instead: write the full label, ask whether ANY
     bar overflows, and if one does, shorten ALL of them. That is exactly the
     "no ellipsis" requirement, tested rather than predicted, and it holds for
     any future grid change. All-or-nothing keeps the label uniform per width -
     one card saying "Buy" beside another saying "ADD TO CART" is worse than
     either, and every card in a grid row is the same width anyway. */
  var LABEL_FULL = 'ADD TO CART';
  var LABEL_SHORT = 'Buy';
  var labelNow = LABEL_FULL;
  var fitRaf = null;

  function cartLabelText() { return labelNow; }

  function cartLabelEls() {
    return document.querySelectorAll('.mlx-catc__btn[data-mlx-cart] .mlx-atc__label');
  }

  /* elements mid ADDED flash are skipped in both passes - their own timer puts
     the current label back, and "ADDED" is shorter so measuring it would lie */
  function writeLabels(txt) {
    var els = cartLabelEls();
    for (var i = 0; i < els.length; i++) {
      if (els[i].__mlxRevert) { continue; }
      els[i].textContent = txt;
    }
  }

  function fitLabels() {
    var els = cartLabelEls();
    if (!els.length) { return; }
    labelNow = LABEL_FULL;
    writeLabels(LABEL_FULL);
    for (var i = 0; i < els.length; i++) {
      if (els[i].__mlxRevert) { continue; }
      if (els[i].scrollWidth > els[i].clientWidth + 0.5) {
        labelNow = LABEL_SHORT;
        writeLabels(LABEL_SHORT);
        return;
      }
    }
  }

  /* measure once now as well as on the next frame: a background tab never fires
     rAF, and leaving the label unmeasured is the failure this replaced */
  function fitLabelsSoon() {
    fitLabels();
    if (fitRaf) { cancelAnimationFrame(fitRaf); }
    fitRaf = requestAnimationFrame(function () { fitRaf = null; fitLabels(); });
  }

  window.addEventListener('resize', fitLabelsSoon);

  /* ------------------------------------------------------------------ 확인 문구 */
  var toastEl = null;
  var toastTimer = null;

  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mlx-catc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;

    /* Klaviyo 하단 티저(높이 50px, z 90000)와 겹쳤다 — 있을 때만 그만큼 띄운다 */
    var lift = 24;
    var teaser = document.querySelector('[class*="kl-teaser"]');
    if (teaser) {
      var tr = teaser.getBoundingClientRect();
      if (tr.height > 0 && tr.bottom > window.innerHeight - 8) { lift = Math.round(tr.height) + 12; }
    }
    toastEl.style.bottom = 'calc(' + lift + 'px + env(safe-area-inset-bottom, 0px))';

    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  /* ------------------------------------------------------------------ 담긴 신호 */
  function labelOf(btn) {
    if (!btn) { return null; }
    var l = btn.querySelector ? btn.querySelector('.mlx-atc__label') : null;
    if (l) { return l; }
    var card = btn.closest ? btn.closest('.product__grid-item') : null;
    return card ? card.querySelector('.mlx-catc__btn .mlx-atc__label') : null;
  }

  function flashAdded(btn) {
    var lab = labelOf(btn);
    if (!lab || lab.__mlxRevert) { return; }
    var prev = lab.textContent;
    lab.textContent = 'ADDED';
    lab.__mlxRevert = setTimeout(function () {
      /* [2026-08-10 CE] If the viewport crossed the label breakpoint during the
         flash, `prev` is stale - recompute for shop bars. Home bars keep prev. */
      var owner = lab.closest ? lab.closest('.mlx-catc__btn[data-mlx-cart]') : null;
      lab.textContent = owner ? cartLabelText() : prev;
      lab.__mlxRevert = null;
    }, 1600);
  }

  function bumpCount(delta) {
    var els = document.querySelectorAll('[data-bind="itemCount"]');
    for (var i = 0; i < els.length; i++) {
      var n = parseInt((els[i].textContent || '').replace(/[^0-9]/g, ''), 10);
      els[i].textContent = (isNaN(n) ? 0 : n) + delta;
    }
  }

  function paintCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') { return; }
    var els = document.querySelectorAll('[data-bind="itemCount"]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = cart.item_count; }
  }

  function getCart() {
    return fetch(u('cart.js'), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  /* ------------------------------------------------------------------ 담기 */
  function addToCart(variantId, btn) {
    if (!variantId || btn.getAttribute('data-mlx-busy') === '1') { return; }
    btn.setAttribute('data-mlx-busy', '1');
    btn.classList.add('is-busy');

    function done() {
      btn.removeAttribute('data-mlx-busy');
      btn.classList.remove('is-busy');
    }

    /* 기준값을 먼저 확실히 읽고 나서 담는다(병렬로 읽으면 레이스가 난다) */
    getCart()
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; })
      .then(function (before) {
        return fetch(u('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function (res) {
          return res.json().catch(function () { return null; })
            .then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (r) {
          if (!r.ok) {
            toast((r.body && (r.body.description || r.body.message)) || 'Could not add to cart');
            done();
            return;
          }

          /* 2xx = 담겼다는 명시적 응답. 라벨·배지는 지금 바꾸고,
             토스트만 /cart.js 재확인 뒤에 낸다(거짓 성공 방지). */
          flashAdded(btn);
          bumpCount(1);

          if (before === null) {
            getCart().then(paintCount).catch(function () {});
            done();
            return;
          }
          verify(before, 0, done);
        });
      })
      .catch(function () { done(); });
  }

  function verify(before, tries, done) {
    if (tries > 8) { done(); return; }
    setTimeout(function () {
      getCart()
        .then(function (c) {
          if (c.item_count > before) {
            paintCount(c);
            toast('Added to cart');
            done();
          } else {
            verify(before, tries + 1, done);
          }
        })
        .catch(function () { verify(before, tries + 1, done); });
    }, 300);
  }

  /* ------------------------------------------------------------------ 카드 데이터 */
  /* Liquid `| handle` 과 같은 규칙 */
  function handleize(s) {
    return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function readProduct(card) {
    if (card.__mlxProduct !== undefined) { return card.__mlxProduct; }
    var f = card.querySelector('.product_form[data-product]');
    var p = null;
    if (f) {
      try { p = JSON.parse(f.getAttribute('data-product')); } catch (e) { p = null; }
    }
    card.__mlxProduct = p;
    return p;
  }

  function readShades(card) {
    if (card.__mlxShades !== undefined) { return card.__mlxShades; }
    var ul = card.querySelector('.mlx-card-dots[data-mlx-shades]');
    var map = null;
    if (ul) {
      map = {};
      var raw = ul.getAttribute('data-mlx-shades') || '';
      raw.split('||').forEach(function (chunk) {
        var a = chunk.split('::');
        if (a.length >= 3 && a[0].trim()) { map[a[0].trim()] = a[2].trim(); }
      });
    }
    card.__mlxShades = map;
    return map;
  }

  /* 카드의 `.product-thumbnail__price` 직속 `.money` = 현재가.
     정가(취소선)는 `.product-thumbnail__was-price` 안에 따로 있어 잡히지 않는다. */
  function priceInfo(card) {
    var box = card.querySelector('.product-thumbnail__price');
    if (!box) { return null; }
    var money = null;
    for (var i = 0; i < box.children.length; i++) {
      if (box.children[i].classList.contains('money')) { money = box.children[i]; break; }
    }
    var txt = money ? money.textContent.replace(/\s+/g, ' ').trim() : '';
    /* [2026-08-10 CE] The compare-at price rides along now, so the bar can show
       both. It is read from its own node, never derived. */
    var wasBox = box.querySelector('.product-thumbnail__was-price');
    var was = wasBox ? wasBox.textContent.replace(/\s+/g, ' ').trim() : '';
    return { text: txt, was: was, sale: !!wasBox };
  }

  function notifyInfo(card) {
    var n = card.querySelector('.mlx-card-notify');
    if (!n) { return null; }
    var v = n.getAttribute('data-mlx-notify-variant');
    var co = n.getAttribute('data-mlx-notify-co');
    if (!v || !co) { return null; }
    return { variant: v, company: co, title: n.getAttribute('data-mlx-notify-title') || '' };
  }

  function sized(url, w) {
    if (!url) { return url; }
    var s = String(url);
    if (s.indexOf('data:') === 0) { return s; }
    if (/[?&]width=/.test(s)) { return s; }
    return s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  function shadeItems(card) {
    var p = readProduct(card);
    if (!p || !p.variants || !p.variants.length) { return null; }

    var oi = 0;
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (/colou?r|shade/i.test(opts[i])) { oi = i; }
    }

    var shades = readShades(card);
    var seen = {};
    var out = [];
    p.variants.forEach(function (v) {
      var name = (v.options && v.options[oi] != null) ? v.options[oi] : v.title;
      if (name == null || seen[name]) { return; }
      seen[name] = 1;
      var img = (shades && shades[handleize(name)]) ||
                sized((v.featured_image && v.featured_image.src) || p.featured_image || '', 80);
      out.push({ id: v.id, name: String(name), available: !!v.available, img: img });
    });

    out.__label = /colou?r|shade/i.test(opts[oi] || '') ? 'Choose a shade' : 'Choose an option';
    return out;
  }

  /* ---------------------------------------------------------------- 홈 베스트셀러 카드 데이터
     [2026-08-10 CD] Home cards (sections/index__best-seller-cards.liquid) are a
     different component: no `.product_form[data-product]`, no `.mlx-card-dots`.
     That Liquid file is NOT touched - what the sheet needs is already rendered:
       swatch : `.bsc-dot img`. That section resolves
                `images['<variant title handle>.png']` first = the same Shopify
                Files flat swatch the shop sheet uses, already at
                `80x80_crop_center`. Checked all 18 dots (12 + 6): zero
                product-photo fallbacks, so no colour drift, no unsized original.
     Only stock is missing from the DOM, so the variant list comes from
     `/products/<handle>.js` - one cached call per product, warmed on first
     intent. It is also the authoritative list: the dot loop is `limit: 12`, so
     a 13th shade would silently vanish from a DOM-only sheet. */
  var bscCache = {};

  function bscProduct(handle) {
    if (!bscCache[handle]) {
      bscCache[handle] = fetch(u('products/' + handle + '.js'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return bscCache[handle];
  }

  function bscSwatches(card) {
    var map = {};
    var dots = card.querySelectorAll('.bsc-dot');
    for (var i = 0; i < dots.length; i++) {
      var img = dots[i].querySelector('img');
      var t = dots[i].getAttribute('title') || '';
      if (img && t) { map[handleize(t)] = img.getAttribute('src'); }
    }
    return map;
  }

  function bscBuild(p, sw) {
    if (!p || !p.variants || !p.variants.length) { return null; }

    /* `/products/x.js` returns options as objects; `data-product` returns plain
       strings. Accept both rather than guessing. */
    var oi = 0;
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var nm = (opts[i] && opts[i].name) ? opts[i].name : opts[i];
      if (/colou?r|shade/i.test(String(nm))) { oi = i; }
    }

    var seen = {};
    var out = [];
    p.variants.forEach(function (v) {
      var name = (v.options && v.options[oi] != null) ? v.options[oi] : v.title;
      if (name == null || seen[name]) { return; }
      seen[name] = 1;
      /* Same fallback contract as shadeItems: never hand an unsized original to
         the sheet - 12 product cuts came to 7.96MB (measured 2026-08-09). */
      var img = sw[handleize(name)] ||
                sized((v.featured_image && v.featured_image.src) || p.featured_image || '', 80);
      out.push({ id: v.id, name: String(name), available: !!v.available, img: img });
    });
    return out.length ? out : null;
  }

  /* ------------------------------------------------------------------ 배경 스크롤 잠금
     overflow:hidden 만으로는 iOS 에서 안 잡힌다 → position:fixed + top:-scrollY. */
  var lockY = 0;
  var lockOn = false;

  function lockScroll() {
    if (lockOn) { return; }
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    var b = document.body;
    b.__mlxPrev = { position: b.style.position, top: b.style.top, left: b.style.left,
                    right: b.style.right, width: b.style.width, paddingRight: b.style.paddingRight };
    b.style.position = 'fixed';
    b.style.top = (-lockY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    if (sbw > 0) { b.style.paddingRight = sbw + 'px'; }
    lockOn = true;
  }

  function unlockScroll() {
    if (!lockOn) { return; }
    var b = document.body;
    var p = b.__mlxPrev || {};
    b.style.position = p.position || '';
    b.style.top = p.top || '';
    b.style.left = p.left || '';
    b.style.right = p.right || '';
    b.style.width = p.width || '';
    b.style.paddingRight = p.paddingRight || '';
    lockOn = false;
    window.scrollTo(0, lockY);
  }

  /* ------------------------------------------------------------------ 시트 셸
     PDP `.mlx-satc-sheet*` (assets/mlx-sticky-atc.css) 를 클래스째 재사용한다.
     여기서 시트 디자인을 새로 그리지 않는다. */
  var openEl = null;
  var lastFocus = null;

  function focusables() {
    if (!openEl) { return []; }
    var panel = openEl.querySelector('.mlx-satc-sheet__panel');
    if (!panel) { return []; }
    var all = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return [].filter.call(all, function (el) {
      return !el.disabled && el.getAttribute('tabindex') !== '-1' && el.getBoundingClientRect().height > 0;
    });
  }

  function closeSheet() {
    if (!openEl) { return; }
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden', 'true');
    openEl = null;
    document.removeEventListener('keydown', onSheetKey, true);
    unlockScroll();
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function onSheetKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(); return; }

    if (e.key !== 'Tab') { return; }
    var f = focusables();
    if (!f.length) { return; }
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !openEl.contains(active)) { e.preventDefault(); last.focus(); }
    } else {
      if (active === last || !openEl.contains(active)) { e.preventDefault(); first.focus(); }
    }
  }

  function makeShell(mark) {
    var root = document.createElement('div');
    root.className = 'mlx-satc-sheet mlx-catc-sheet ' + mark;
    root.setAttribute('aria-hidden', 'true');

    var scrim = document.createElement('div');
    scrim.className = 'mlx-satc-sheet__scrim';
    scrim.addEventListener('click', closeSheet);
    root.appendChild(scrim);

    var panel = document.createElement('div');
    panel.className = 'mlx-satc-sheet__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    root.appendChild(panel);

    var head = document.createElement('div');
    head.className = 'mlx-satc-sheet__head';
    var title = document.createElement('span');
    title.className = 'mlx-satc-sheet__title';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'mlx-satc-sheet__close';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '&times;';
    x.addEventListener('click', closeSheet);
    head.appendChild(title);
    head.appendChild(x);
    panel.appendChild(head);

    document.body.appendChild(root);
    return { root: root, panel: panel, title: title };
  }

  function openShell(sh, btn, focusEl) {
    lastFocus = btn || null;
    openEl = sh.root;
    sh.root.classList.add('is-open');
    sh.root.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onSheetKey, true);
    lockScroll();
    if (focusEl && focusEl.focus) { focusEl.focus(); }
  }

  /* ------------------------------------------------------------------ 쉐이드 시트 */
  var shadeSheet = null;
  var shadeList = null;

  function openSheet(card, btn) {
    var items = shadeItems(card);

    /* 데이터가 없으면 죽은 버튼으로 두지 않고 PDP 로 보낸다(방어용 폴백) */
    if (!items || !items.length) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) { window.location.href = link.getAttribute('href'); }
      return;
    }

    var sel0 = card.querySelector('.product_form select[name="id"]');
    showShadeSheet(items, items.__label, sel0 ? parseInt(sel0.value, 10) : null, btn,
      function (it) { addToCart(it.id, btn); });
  }

  /* [2026-08-10 CD] Sheet rendering split out of openSheet so the home cards
     reuse this exact component instead of growing a second one. Callers supply
     the items and what to do with the pick; nothing about the markup, the
     swatch source or the focus behaviour differs between call sites. */
  function showShadeSheet(items, label, currentId, btn, pick) {
    if (!shadeSheet) {
      shadeSheet = makeShell('mlx-catc-sheet--shade');
      shadeList = document.createElement('ul');
      shadeList.className = 'mlx-satc-sheet__list';
      shadeSheet.panel.appendChild(shadeList);
    }

    shadeSheet.title.textContent = label;
    shadeSheet.panel.setAttribute('aria-label', label);

    shadeList.innerHTML = '';
    items.forEach(function (it) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mlx-satc-sheet__item';
      b.setAttribute('aria-current', it.id === currentId ? 'true' : 'false');
      if (!it.available) { b.disabled = true; }

      var sw = document.createElement('img');
      sw.className = 'mlx-satc-sheet__sw';
      sw.alt = '';
      sw.setAttribute('aria-hidden', 'true');
      if (it.img) { sw.setAttribute('src', it.img); }
      b.appendChild(sw);

      var nm = document.createElement('span');
      nm.className = 'mlx-satc-sheet__nm';
      nm.textContent = it.name;
      b.appendChild(nm);

      if (!it.available) {
        var so = document.createElement('span');
        so.className = 'mlx-satc-sheet__so';
        so.textContent = 'Sold out';
        b.appendChild(so);
      }

      b.addEventListener('click', function () {
        if (!it.available) { return; }
        closeSheet();
        pick(it);
      });

      li.appendChild(b);
      shadeList.appendChild(li);
    });

    var cur = shadeList.querySelector('.mlx-satc-sheet__item[aria-current="true"]:not([disabled])') ||
              shadeList.querySelector('.mlx-satc-sheet__item:not([disabled])');
    openShell(shadeSheet, btn, cur);
  }

  /* ------------------------------------------------------------------ NOTIFY ME 시트
     출시예정 카드 전용. 쉐이드 시트와 같은 껍데기·같은 디자인 언어. */
  var notifySheet = null;
  var notifyUI = null;

  function buildNotify() {
    notifySheet = makeShell('mlx-catc-sheet--notify');

    var wrap = document.createElement('div');
    wrap.className = 'mlx-catc-notify';

    var p = document.createElement('p');
    p.className = 'mlx-catc-notify__p';
    wrap.appendChild(p);

    var form = document.createElement('form');
    form.className = 'mlx-catc-notify__row';
    form.setAttribute('novalidate', 'novalidate');

    var email = document.createElement('input');
    email.type = 'email';
    email.className = 'mlx-catc-notify__email';
    email.setAttribute('name', 'email');
    email.setAttribute('autocomplete', 'email');
    email.setAttribute('placeholder', 'Email address');
    email.setAttribute('aria-label', 'Email address');
    form.appendChild(email);

    var send = document.createElement('button');
    send.type = 'submit';
    send.className = 'mlx-catc-notify__send';
    send.textContent = 'Notify me';
    form.appendChild(send);

    wrap.appendChild(form);

    var note = document.createElement('p');
    note.className = 'mlx-catc-notify__note';
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');
    wrap.appendChild(note);

    notifySheet.panel.appendChild(wrap);

    notifyUI = { p: p, form: form, email: email, send: send, note: note, info: null };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitNotify();
    });
  }

  function submitNotify() {
    var ui = notifyUI;
    if (!ui || !ui.info) { return; }
    var email = (ui.email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      ui.note.textContent = 'Please enter a valid email address.';
      ui.note.classList.add('is-err');
      ui.email.focus();
      return;
    }
    ui.note.classList.remove('is-err');
    ui.note.textContent = '';
    ui.send.disabled = true;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + ui.info.variant } }
        }
      }
    };

    fetch(KLAVIYO_EP + '?company_id=' + encodeURIComponent(ui.info.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REV },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        ui.send.disabled = false;
        if (res.ok || res.status === 202) {
          /* ★ 확정 문구는 NOTIFY_CONFIRMED 가 true 일 때만.
             지금은 "보냈다" 는 사실만 말한다 — 구독됐다고 말하지 않는다. */
          ui.form.style.display = 'none';
          ui.note.textContent = NOTIFY_CONFIRMED
            ? "You're on the list. We'll email you the moment it launches."
            : 'Request sent.';
        } else {
          ui.note.textContent = 'Could not send. Please try again.';
          ui.note.classList.add('is-err');
        }
      })
      .catch(function () {
        ui.send.disabled = false;
        ui.note.textContent = 'Could not send. Please try again.';
        ui.note.classList.add('is-err');
      });
  }

  function openNotify(info, btn) {
    if (!notifySheet) { buildNotify(); }
    notifyUI.info = info;
    notifySheet.title.textContent = 'Notify me';
    notifySheet.panel.setAttribute('aria-label', 'Notify me: ' + info.title);
    notifyUI.p.textContent = info.title
      ? "We'll email you when " + info.title + " launches."
      : "We'll email you when this launches.";
    notifyUI.form.style.display = '';
    notifyUI.note.textContent = '';
    notifyUI.note.classList.remove('is-err');
    notifyUI.email.value = '';
    notifyUI.send.disabled = false;
    openShell(notifySheet, btn, notifyUI.email);
  }

  /* ------------------------------------------------------------------ 카드에 붙이기 */
  function attach(card) {
    if (card.__mlxCatc) { return; }
    var cap = card.querySelector('.thumbnail__caption');
    if (!cap) { return; }
    card.__mlxCatc = true;

    var form = card.querySelector('.product_form[data-product]');
    /* 담을 수 있는가 = 테마가 `{% if product.available %}` 안에서 ATC 를 렌더했는가.
       JSON 파싱은 시트를 처음 열 때만(lazy) — 카드 28장을 로드 시점에 파싱하면 비싸다. */
    var buyable = !!(form && form.querySelector('.button--add-to-cart'));

    /* 제품명 아래 `12 shades` — 누르면 같은 쉐이드 시트가 열린다.
       담을 수 없는 상품에서는 비활성(열어 봐야 고를 게 없다). */
    var shadeBtn = card.querySelector('.mlx-card-shades');
    if (shadeBtn && !shadeBtn.__mlxBound) {
      shadeBtn.__mlxBound = true;
      if (buyable && form.querySelector('select[name="id"]')) {
        shadeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          openSheet(card, shadeBtn);
        });
      } else {
        shadeBtn.disabled = true;
        shadeBtn.removeAttribute('aria-haspopup');
        shadeBtn.classList.add('is-static');
      }
    }

    var wrap = document.createElement('div');
    wrap.className = 'mlx-catc';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mlx-atc mlx-catc__btn';   // 규격은 mlx-atc.css 가 단독 소유

    var lab = document.createElement('span');
    lab.className = 'mlx-atc__label';
    btn.appendChild(lab);

    var title = card.querySelector('.product-thumbnail__title');
    var titleTxt = title ? title.textContent.trim() : '';

    /* 가격을 바 안으로 (⑨). /pages/shop 에서만 — 컬렉션·검색 그리드는 현행 유지.
       실제로 넣었을 때만 카드의 가격 줄을 지운다(대체물 없이 사라지는 일 방지). */
    var pi = SHOP_ALL ? priceInfo(card) : null;
    if (pi && pi.text) {
      var pel = document.createElement('span');
      pel.className = 'mlx-atc__price';
      /* [2026-08-10 CE] Sale card = strikethrough compare-at, then the selling
         price. `s` carries the line from the UA; the aria-label is what a screen
         reader gets, because "$30.00 $26.00" read flat is two prices, not one
         discount. */
      if (pi.was) {
        var wel = document.createElement('s');
        wel.className = 'mlx-atc__was';
        wel.textContent = pi.was;
        pel.appendChild(wel);
        pel.setAttribute('aria-label', 'Sale price ' + pi.text + ', regular price ' + pi.was);
      }
      pel.appendChild(document.createTextNode(pi.text));
      btn.appendChild(pel);
      card.classList.add(pi.sale ? 'mlx-price-sale' : 'mlx-price-moved');
    } else {
      btn.classList.add('mlx-atc--no-price');
    }

    wrap.appendChild(btn);
    cap.appendChild(wrap);

    if (!buyable) {
      /* 출시예정 ↔ 품절은 **폼의 유무**로 갈린다(테마 Liquid 구조 실측).
         · 폼 자체가 없다   → quick-shop-button 의 coming-soon 게이트 = COMING SOON
         · 폼은 있고 ATC 만 없다 → product__form 의 available 게이트 = SOLD OUT
         배지는 /pages/shop 에만 있으므로 배지만 보면 컬렉션에서 오판한다. */
      var ni = notifyInfo(card);
      var soon = !form;

      if (soon && ni) {
        /* ⑧ 출시예정 = 상단 배지 1회 + NOTIFY ME. 중간 `Coming Soon` 은 제거됐다. */
        lab.textContent = 'NOTIFY ME';
        btn.classList.add('mlx-atc--no-price');
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.setAttribute('aria-label', 'Notify me when ' + (titleTxt || 'this') + ' launches');
        wrap.classList.add('mlx-catc--notify');
        btn.addEventListener('click', function () { openNotify(ni, btn); });
        return;
      }

      lab.textContent = soon ? 'COMING SOON' : 'SOLD OUT';
      btn.disabled = true;
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
      return;
    }

    /* [2026-08-10 CE] data-mlx-cart marks the bars whose label follows the
       breakpoint. aria-label stays the full sentence at every width - the visual
       label shortens for space, the announced one must not. */
    btn.setAttribute('data-mlx-cart', '1');
    lab.textContent = cartLabelText();
    btn.setAttribute('aria-label', 'Add to cart' + (titleTxt ? ': ' + titleTxt : ''));

    var sel = form.querySelector('select[name="id"]');
    if (sel) {
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', function () { openSheet(card, btn); });
      return;
    }

    var hidden = form.querySelector('input[name="id"]');
    var vid = hidden ? parseInt(hidden.value, 10) : 0;
    btn.addEventListener('click', function () { addToCart(vid, btn); });
  }

  /* ------------------------------------------------------------------ 홈 베스트셀러 카드
     [2026-08-10 CD] The bar is a real `<form>` whose hidden id is the first
     available variant, so a shade product added shade #1 whatever the customer
     meant (measured: Lip Butter -> 1. Agave, Lip Treatment -> 0 Glass).
     Bound on submit, not click: keyboard Enter takes the same path, and if this
     file fails to load the native post still works.
     Not gated on `hover:none` the way `.mlx-catc` is. That gate exists because
     the shop grid hands desktop a hover quick-shop; these cards have no hover
     path, their bar is always visible, and their dots are plain PDP links that
     never retarget the bar - so desktop has the identical bug. */
  function attachBsc(card) {
    if (card.__mlxBsc) { return; }
    var form = card.querySelector('form.mlx-atc-form');
    var btn = form ? form.querySelector('button.mlx-atc') : null;
    if (!form || !btn) { return; }   /* sold out renders an <a>, not a form */
    card.__mlxBsc = true;

    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? (link.getAttribute('href') || '') : '';
    var m = href.match(/\/products\/([^/?#]+)/);
    var hasDots = card.querySelectorAll('.bsc-dot').length > 0;

    if (!hasDots || !m) {
      /* Single-variant card. Route it through the same cart/add.js contract the
         shop cards use, so one page does not mix a toast with a page reload. */
      var hid = form.querySelector('input[name="id"]');
      var vid = hid ? parseInt(hid.value, 10) : 0;
      if (!vid) { return; }
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(vid, btn); });
      return;
    }

    var handle = m[1];
    var titleEl = card.querySelector('.bsc-title');
    var t = titleEl ? titleEl.textContent.trim() : '';

    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-label', 'Add to cart' + (t ? ': ' + t : '') + ', choose a shade');

    /* Warm the lookup on first intent so the tap itself never waits on network.
       Not fired at load: three product payloads on the home page for a sheet
       most visitors never open is not a trade worth making. */
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      card.addEventListener(ev, function () { bscProduct(handle); }, { once: true, passive: true });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.getAttribute('data-mlx-busy') === '1') { return; }
      btn.classList.add('is-busy');
      bscProduct(handle).then(function (p) {
        btn.classList.remove('is-busy');
        var items = bscBuild(p, bscSwatches(card));
        /* No data must never fall through to the native post - that is exactly
           the silent first-shade bug. Hand them the PDP instead, same as
           openSheet does for the shop cards. */
        if (!items) { window.location.href = href; return; }
        showShadeSheet(items, 'Choose a shade', null, btn, function (it) { addToCart(it.id, btn); });
      });
    });
  }

  function scan(root) {
    var r = root || document;
    var cards = r.querySelectorAll('.product__grid-item');
    for (var i = 0; i < cards.length; i++) { attach(cards[i]); }
    var bsc = r.querySelectorAll('.bsc-card');
    for (var j = 0; j < bsc.length; j++) { attachBsc(bsc[j]); }
  }

  function init() {
    SHOP_ALL = document.body.classList.contains('page-shop-all');
    scan(document);
    /* [2026-08-10 CE] before the first paint: the bars exist now, so the label
       can be measured against them instead of guessed from the viewport */
    fitLabels();

    /* 무한 스크롤 / 더 보기로 카드가 추가되는 그리드가 있다 */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        var grew = false;
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) { continue; }
            if (n.classList && n.classList.contains('product__grid-item')) { attach(n); grew = true; }
            else if (n.classList && n.classList.contains('bsc-card')) { attachBsc(n); grew = true; }
            else if (n.querySelector) {
              scan(n);
              if (n.querySelector('.product__grid-item, .bsc-card')) { grew = true; }
            }
          }
        }
        /* [2026-08-10 CE] Re-measure ONLY when cards actually arrived.
           !! Calling this unconditionally hangs the page. `writeLabels` assigns
           textContent, which replaces a text node = a childList mutation inside
           the subtree this observer watches, so it re-enters itself forever
           (reproduced: renderer froze on /pages/shop). The nodeType!==1 skip is
           not enough on its own - the guard has to be that a CARD appeared. */
        if (grew) { fitLabelsSoon(); }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
